// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "#vk-video_code:hover img{-webkit-filter:brightness(3);filter:brightness(3)}", "",{"version":3,"sources":["/builds/vkplay/media/backend/frontend/public/css/text-editor.css"],"names":[],"mappings":"AAEQ,yBACI,4BAAA,CAAA,oBAAA","file":"text-editor.css","sourcesContent":["#vk-video_code {\n    &:hover {\n        img {\n            filter: brightness(3);\n        }\n    }\n}"]}]);
// Exports
module.exports = exports;
